"use client";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthError, selectAuthStatus } from "store";
import { loginUser } from "store";
import Logo from "./logo";
import { Icon } from "components";
import EveLogo from "icons/src/everest-logoblack.svg";
import { Button } from "ui/components/button";
import { Input } from "ui/components/input";
import { Link, useNavigate } from "react-router-dom";
import { EYE_CLOSE, EYE_OPEN } from "icons";

export function SignIn() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const authStatus = useSelector(selectAuthStatus);
  const authError = useSelector(selectAuthError);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password }));
    navigate("/");
  };
  return (
    <div className="min-h-screen bg-background md:p-16 gap-x-6 flex justify-center items-center relative">
      <div className="w-full flex items-top justify-center">
        <div className="max-w-sm px-6 py-16 md:p-0 w-full ">
          <div className="space-y-6 mb-10 items-center flex flex-col">
            <img src={EveLogo} alt="Logo" className="w-55" />
          </div>
          <div className="space-y-4 mb-2">
            <div className="space-y-2">
              <Input
                id="email"
                placeholder="Email or username"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div>
                <div className="relative">
                  <Input
                    id="password"
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit(e);
                      }
                    }}
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <Icon
                        icon={EYE_CLOSE}
                        className="h-6 w-6 opacity-60"
                        aria-hidden="true"
                      />
                    ) : (
                      <Icon
                        icon={EYE_OPEN}
                        className="h-6 w-6 opacity-60"
                        aria-hidden="true"
                      />
                    )}
                  </button>
                </div>
                <div className="flex justify-end mt-2">
                  <Link
                    to="/forgot-password"
                    className="text-blue-600 text-sm hover:underline"
                  >
                    Forgot Password?
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col space-y-6">
            {authError && (
              <p className="text-red-500 text-sm text-center mb-4">
                {authError}
              </p>
            )}
            <Button
              className="w-full"
              onClick={handleSubmit}
              disabled={authStatus === "loading"}
            >
              Log in
            </Button>
          </div>

          <div className="w-full flex justify-center items-center gap-2 mt-8 opacity-80">
            <span className="text-ms text-muted-foreground">Powered by</span>
            <Logo width={80} height={25} />
          </div>
        </div>
      </div>

      {/* <div
        className="fixed bottom-4 right-4 flex items-center gap-2 opacity-80"
        style={{ zIndex: 50 }}
      >
        <span className="text-ms text-muted-foreground">Powered by</span>
        <Logo width={80} height={25} />
      </div> */}
    </div>
  );
}
